module.exports = __webpack_public_path__ + "img/service-activity.eee0aaf3.jpg";